import { Instance } from "mobx-state-tree";
import { SurveyRuleStore } from "./SurveyRuleStore";
import { useSurveyStore } from "../../store/Hooks";
import { GetSurveyRulesStore } from "./GetSurveyRulesStore";
import { SaveSurveyRulesStore } from "./SaveSurveyRulesStore";
import { GetSurveyRuleKeyOptionsStore } from "./GetSurveyRuleKeyOptionsStore";
import { GetSurveyRuleValueOptionsStore } from "./GetSurveyRuleValueOptionsStore";
import { GetSurveyRuleTargetOptionsStore } from "./GetSurveyRuleTargetOptionsStore";

export const useSurveyRuleStore = (): Instance<typeof SurveyRuleStore> =>
  useSurveyStore().surveyRuleStore;

export const useGetSurveyRulesStore = (): Instance<
  typeof GetSurveyRulesStore
> => useSurveyRuleStore().getSurveyRulesStore;

export const useGetSurveyRuleKeyOptionsStore = (): Instance<
  typeof GetSurveyRuleKeyOptionsStore
> => useSurveyRuleStore().getSurveyRuleKeyOptionsStore;

export const useGetSurveyRuleValueOptionsStore = (): Instance<
  typeof GetSurveyRuleValueOptionsStore
> => useSurveyRuleStore().getSurveyRuleValueOptionsStore;

export const useGetSurveyRuleTargetOptionsStore = (): Instance<
  typeof GetSurveyRuleTargetOptionsStore
> => useSurveyRuleStore().getSurveyRuleTargetOptionsStore;

export const useSaveSurveyRulesStore = (): Instance<
  typeof SaveSurveyRulesStore
> => useSurveyRuleStore().saveSurveyRulesStore;
